import { render, staticRenderFns } from "./StatementsDispatch.vue?vue&type=template&id=2152ee56"
import script from "./StatementsDispatch.vue?vue&type=script&lang=js"
export * from "./StatementsDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports